document.addEventListener('DOMContentLoaded', function() {
  const slideshowSections = document.querySelectorAll('.slideshow-section');
  
  slideshowSections.forEach(section => {
    const autoRotate = section.dataset.autoRotate === 'true';
    
    new Swiper(section.querySelector('.swiper'), {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: autoRotate ? {
        delay: 5000,
        disableOnInteraction: false,
      } : false,
      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: section.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  });
}); 